import { DomainSearchSuiteModule, SearchRecommendationModule } from '@wix/domains-search-suite';
import React from 'react';
import { useIsGateRevamp3Enabled } from '../../../hooks/useIsGateRevamp3Enabled';
import { useIsSiteLevelGateOptimized } from '../../../hooks/useIsSiteLevelGateOptimized';
import { HarmonyThemeProvider } from '@wix/core-domain-search';
import { useIsBmHarmonyThemeEnabled } from '../../../utils/harmonyTheme';
import { SearchGateHomeContent } from '../../SearchGateHome';
import { SiteLevelGateHomeOptimizedContent } from '../../SiteLevelGateOptimized';
export const SiteLevelGateHomePage = _ref => {
  let handlers = _ref.handlers,
    externalViewer = _ref.externalViewer;
  const isSiteLevelOptimized = useIsSiteLevelGateOptimized();
  const isRevampedGate = useIsGateRevamp3Enabled();
  const isOptimized = isSiteLevelOptimized || isRevampedGate;
  const isHarmonyTheme = useIsBmHarmonyThemeEnabled();
  return /*#__PURE__*/React.createElement(DomainSearchSuiteModule.Provider, {
    translations: {
      Loading: /*#__PURE__*/React.createElement(React.Fragment, null)
    },
    actions: {
      enabledActions: ['alreadyAssignedToThisSite', 'alreadyAssigned', 'floatingDomain'],
      handlers,
      siteInfo: {
        externalViewer: Boolean(externalViewer)
      }
    }
  }, /*#__PURE__*/React.createElement(SearchRecommendationModule.Provider, null, /*#__PURE__*/React.createElement(HarmonyThemeProvider, {
    enabled: isHarmonyTheme
  }, isOptimized ? /*#__PURE__*/React.createElement(SiteLevelGateHomeOptimizedContent, null) : /*#__PURE__*/React.createElement(SearchGateHomeContent, null))));
};
//# sourceMappingURL=SiteLevelGateHomePage.js.map